import { RefreshCw } from "lucide-react";
import { HostedApiError } from "../lib/hosted";

export interface FailureDetails {
  message: string;
  code?: string;
  requestId?: string;
  retryable: boolean;
}

export function failureDetails(error: unknown, fallback: string): FailureDetails {
  if (error instanceof HostedApiError) {
    return {
      message: error.message,
      code: error.code,
      requestId: error.requestId,
      retryable: error.retryable,
    };
  }
  if (error instanceof TypeError) {
    return {
      message: "CHEW could not reach the service. Check your connection and try again.",
      retryable: true,
    };
  }
  return {
    message: error instanceof Error ? error.message : fallback,
    retryable: true,
  };
}

export function FailureState({
  title,
  error,
  fallback,
  backHref,
}: {
  title: string;
  error: unknown;
  fallback: string;
  backHref?: string;
}) {
  const details = failureDetails(error, fallback);
  return (
    <main className="fatal-state" role="alert">
      <div className="fatal-card">
        <div className="fatal-brand">CHEW</div>
        <strong>{title}</strong>
        <p>{details.message}</p>
        <div className="fatal-actions">
          {details.retryable && (
            <button className="primary-button" type="button" onClick={() => window.location.reload()}>
              <RefreshCw size={14} aria-hidden="true" />
              Try again
            </button>
          )}
          {backHref && <a className="secondary-button" href={backHref}>Back to queue</a>}
        </div>
        {(details.code || details.requestId) && (
          <div className="fatal-reference" aria-label="Error reference">
            {details.code && <span>{details.code.replaceAll("_", " ")}</span>}
            {details.requestId && <code>{details.requestId}</code>}
          </div>
        )}
        {details.requestId && <small>If this persists, send the reference above to the CHEW team.</small>}
      </div>
    </main>
  );
}
